// Brand identity — edit here (admin panel branding overrides these at runtime).
export const BRAND = {
  app_name: "MinitAI",
  tagline: "Minit mesyuarat automatik untuk Malaysia",
  primary_color: "#7C3AED",
  navy_color: "#0F172A",
  company_name: "minitai.app",
  company_reg: "",
  company_address: "Johor Bahru, Malaysia",
  support_email: "support@minitai.app",
};

// Owner-provided testimonials/stats. Leave empty until real data is supplied — nothing fake is shown.
export const TESTIMONIALS = [];
export const STATS = [];
